export default class IntercomService {
  private static INTERCOM_HOST: string = 'https://api-iam.intercom.io';

  public static init(
    intercomAppId: string,
    userId: number,
    userEmail: string,
    userFullName: string,
    userCreatedDateValue: number,
    userHash: string,
  ): void {
    if (typeof window !== 'undefined') {
      (window as WindowExtended).intercomSettings = {
        api_base: this.INTERCOM_HOST,
        app_id: intercomAppId,
      };

      if ((window as WindowExtended).Intercom) {
        (window as WindowExtended).Intercom('boot', {
          app_id: intercomAppId,
          user_id: userId,
          user_hash: userHash,
          email: userEmail,
          name: userFullName,
          created_at: Math.floor(userCreatedDateValue / 1000),
        });
      }
    }
  }
}
